import { ModelCategory, TrussEnvelope } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { ComponentDesignSchema } from './ComponentDesignSchema';

export const TrussEnvelopeSchema = new ModelSchema<TrussEnvelope>('trussEnvelope', {
  category: ModelCategory.IntermediateModel,

  displayName: (envelope) => `Envelope ${envelope.name}`,
  properties: {},
  children: {
    componentDesign: ComponentDesignSchema,
  },
});
